$(document).ready(function () {
/*$('.has-submenu > a').each(function(){
    var sub = $(this).next('ul');
    $(this).clone().prependTo(sub).wrap('<li class="hide-for-large"></li>');
});*/
	$(document).foundation();
	iniShareReveal();
	$(window).scroll(function () {($(this).scrollTop() > 20)?$('#btn-chat').stop(true).addClass('back-top-show'):$('#btn-chat').stop(true).removeClass('back-top-show');});
	
	//$('#back-top').click(function () {$('body, html').stop(true).animate({scrollTop: 0}, 600);});
	
	
	
	/*$(window).scroll(function () {($(this).scrollTop() > 20)?$('#back-top').stop(true).addClass('back-top-show'):$('#back-top').stop(true).removeClass('back-top-show');});
	
	$('#back-top').click(function () {$('body, html').stop(true).animate({scrollTop: 0}, 600);});*/
	
	
	var elemNavIntern = ['.menu-ol','.medium-horizontal'], classActive = 'page-actuelle', pageLink = window.location.pathname, pageLinkCln = pageLink.substring(1);
	for(var i=0;i<elemNavIntern.length;i++){
		$(elemNavIntern[i]+' a[href="'+pageLink+'"]').parent('li').addClass(classActive);
	}
	
		//*******************Menu****
	//------scrollhide-nav
	var height = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
	var prev = 0;
    var $window = $(window);
    var nav = $('.scrollhide-nav');

	    $window.on('scroll', function () {
        var scrollTop = $window.scrollTop();
			if(!$('#offCanvasRight').hasClass('is-open')){
			   if (scrollTop > 150) {
				nav.toggleClass('hidden', scrollTop > prev);
			} else if (nav.hasClass('hidden')) {
				nav.toggleClass('hidden', false);
			}
			   }
			
			prev=scrollTop;
        });
	
	///****************************
	
var player = ($(".vimeo-wrapper iframe").length) ? new Vimeo.Player($(".vimeo-wrapper iframe")) :null;
if($('.content-video .responsive-embed').length){
			player = ($(".vimeo-wrapper iframe").length) ? new Vimeo.Player($('.content-video .responsive-embed')) : null;
			$('.section-1').addClass('video_charger');
}

function videoSound(){
	if(!player){
		if($('.content-video .responsive-embed').length){
			player = ($(".vimeo-wrapper iframe").length) ? new Vimeo.Player($('.content-video .responsive-embed')) : null;
		}
	}
	var btn=$('#mute');
	if(btn.data("muted")){
			player.setVolume(1);
			btn.data("muted",0);
			btn.find('.fa').addClass('fa-volume-up').removeClass('fa-volume-off');
		}else{
			player.setVolume(0);
			btn.data("muted",1);
			btn.find('.fa').addClass('fa-volume-off').removeClass('fa-volume-up');
		}
	 	
}
$('#mute').on('click',videoSound);

	setTimeout(function(){AOS.refresh(); }, 2000);
});